<template>
  <div id="app">
    <router-view v-if="isLoginRoute" />
    <el-container v-else class="app-shell">
      <el-header class="app-header">
        <div class="app-title">行走的十三香</div>
        <div class="header-actions">
          <span class="user-label" v-if="userLabel">{{ userLabel }}</span>
          <el-button type="text" class="logout-btn" @click="handleLogout">退出登录</el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu :default-active="$route.path" router>
            <el-menu-item index="/access-keys">访问密钥</el-menu-item>
            <el-menu-item index="/users">用户管理</el-menu-item>
            <el-menu-item index="/chases">方案管理</el-menu-item>
            <el-menu-item index="/chase-users">用户追号管理</el-menu-item>
            <el-menu-item index="/lottery">游戏管理</el-menu-item>
            <el-menu-item index="/calculator">计算器</el-menu-item>
            <el-menu-item index="/omission">数据看板</el-menu-item>
            <el-menu-item index="/access-logs">访问日志</el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="app-content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getStoredUser, logout } from "./services/auth";

export default {
  data() {
    return {
      user: null
    };
  },
  computed: {
    isLoginRoute() {
      const loginRoutes = ["/login", "/script-login", "/script-login/success"];
      return loginRoutes.includes(this.$route.path);
    },
    userLabel() {
      if (!this.user) return "";
      return this.user.nickname || this.user.username || this.user.name || "系统管理员";
    }
  },
  watch: {
    $route() {
      this.syncUser();
    }
  },
  created() {
    this.syncUser();
  },
  methods: {
    syncUser() {
      this.user = getStoredUser();
    },
    async handleLogout() {
      try {
        await logout();
      } finally {
        this.user = null;
        this.$router.replace("/login");
      }
    }
  }
};
</script>

<style scoped>
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-label {
  font-size: 14px;
  color: #e5e7eb;
}

.logout-btn {
  color: #e5e7eb;
}
</style>
